import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { appGroupIdGenerateImage } from "./constants";
import type { PostwsAppGroupIdGenerateImagePayload, PostwsAppGroupIdGenerateImageProps } from "./types";
import { isAiImageGenerationResult } from "./validators";

export const postwsAppGroupIdGenerateImage = reactQueryPostWebsocketAdapter(
  appGroupIdGenerateImage,
  async (signal, { appGroupId, args, jobToken }: PostwsAppGroupIdGenerateImageProps): Promise<{}> => {
    const payload: PostwsAppGroupIdGenerateImagePayload = {
      job_token: jobToken,
      args,
    };

    return await fetch(`/${appGroupId}/generate_image`, "POST", payload, { signal });
  },
  isAiImageGenerationResult
);
